import React from 'react';
import Utilities from '@util/Utilities';
import { BuildingOfficeIcon } from '@heroicons/react/24/outline';
import CompetitorReviewsState from '@app/model/review/state/CompetitorReviewsState';

const CompetitorStatIndicatorPortlet: React.FunctionComponent<{
	competitorReviewsState: CompetitorReviewsState,
	isSelected?: boolean,
	setSelectedHotelId: (hotelId: number) => void
}> = ({ competitorReviewsState, isSelected, setSelectedHotelId }) => {

	return <div onClick={() => setSelectedHotelId(competitorReviewsState.hotelId)}
							className={`relative rounded-lg border px-4 py-3 ${isSelected === true ? 'border-blue-300 bg-blue-100' : 'border-gray-200 bg-gray-50 focus-within:outline focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-blue-600 hover:border-gray-300 cursor-pointer group'}`}>
		<div className="flex flex-wrap items-center justify-between">
			<div className="flex items-center space-x-3 flex-1">
				<div
					className="flex justify-center items-center w-10 h-10 rounded-full bg-gray-100 outline outline-1 -outline-offset-1 outline-black/5 group-hover:bg-blue-50 group-hover:outline-black/10">
					<BuildingOfficeIcon className="h-5 w-5 text-gray-400" />
				</div>
				<div className="min-w-0 flex-1">
					<div>
						<p
							className={`text-sm font-medium text-gray-900 truncate max-w-[10rem] group-hover:text-blue-600`}>
							{competitorReviewsState.hotelName}
						</p>
						<p
							className="truncate text-sm text-gray-500">{competitorReviewsState.statistics.numberOfReviews} reviews</p>
					</div>
				</div>
			</div>
			<div className="flex items-center space-x-6">
				<div className="shrink-0 text-center">
					<p className="text-xs font-medium text-gray-500">Score</p>
					<p
						className="text-xl font-bold leading-none text-gray-900">{Utilities.formatDouble(competitorReviewsState.statistics.score, 1)}</p>
				</div>
				<div className="shrink-0 text-center">
					<p className="text-xs font-medium text-gray-500">Response</p>
					<p
						className="text-xl font-bold leading-none text-gray-900">{Utilities.formatDouble(competitorReviewsState.statistics.responseRate * 100, 1)}%</p>
				</div>
			</div>
		</div>
	</div>;
};

export default CompetitorStatIndicatorPortlet;
